module.exports = __webpack_public_path__ + "static/media/bollnasvapen.d4ae8584.png";